import React from 'react';
import ReactDOM from 'react-dom';
import FormItemEditor from './FormItemEditor';
import FormItemConst from './FormItemConst';
import {RecordFieldChangeStore,AutoSaveBeforeStore} from '../stores/RecordsStore';
import RecordsActions from '../actions/RecordsActions';
import FocusActions from '../actions/FocusActions';
import Warning from '../utils/Warn';
import FormItemDateResolver from './resolver/FormItemDateResolver';
import FormItemDateDisplay from './display/FormItemDateDisplay';

export default class FormItemDateEditor extends FormItemEditor
{
	lookupStates = 
	{
		isShowed:false
	}

	constructor(props) {
		super(props);
		this.initMembers();
		this.initStores();
	}

	initMembers()
	{

	}

	initStores()
	{
		if(!this.props.forLookup)
		{	
			this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
			this.unsubscribeAutoSaveBeforeStore = AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
		}
	}

	componentWillUnmount()
	{
		this.distroyCommonStores();
		if(!this.props.forLookup)
		{
			this.unsubscribeRecordFieldChangeStore();
			this.unsubscribeAutoSaveBeforeStore();
		}
	}

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(observer != this && this.props.dataField == dataField && record == this.record)
		{
			this.setDisplay(newValue);
			this.updateModifiedTag();
		}
	}

	onCmdWriteControlStore(arg,moduleInstanceId,triggerModify)
	{
		if(arg && arg.hasOwnProperty(this.props.xml.name) && this.props.moduleInstanceId == moduleInstanceId)
		{
			var value = arg[this.props.xml.name];
			if(value == "1970-01-01")
				value = "";
			this.setDisplayFieldText(value,triggerModify)
			if(this.props.underQueryGroup)
			{
				this.setQueryGroupEnable(true);			
			}
		}
	}

	dateSelectChange()
	{
		alert('select changeDate')
	}

	showDateDropDown()
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(!nowAllowEdit)
			return;
		var $pickerdropdown = $("div.datepicker");
		this.inQueryGroup = true;

		let _displayStyle = this.props.control.getProperty_DisplayStyle();
		let dataFormat ;
		if(_displayStyle && _displayStyle.DisplayFormat)
		{
			dataFormat = _displayStyle.DisplayFormat;
		}
		else
		{
			// dataFormat = _displayStyle.DisplayFormat;
		}


		if ($pickerdropdown.is(':visible'))
		{
			this.lookupStates.isShowed = false;
			$(this.inputField).datepicker('hide',true);
		}
		else
		{
			this.lookupStates.isShowed = true;
			$(this.inputField).datepicker('show');
			if(dataFormat){
				$(this.inputField).datepicker({
					format: 'yyyy-mm',
					startView: 3,
					minView: 3,
				  });
			}
		}
	}
	showDateDropDownEditor(){
		if(this.props.underQueryGroup){
			this.setState({allowEdit:true});
			$(this.inputField).val('');
			this.record='';
			$(this.inputField).removeAttr("readonly");
			this.showDateDropDown();
		}
	}

	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId)
	{
		super.onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId);
		if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.currentDataFieldChanged = false;
			this.doSetModifiedTagNone();
			if(this.props.dataField)
			{
				var _value = this.record?this.record[this.props.dataField]:'';
			}
			else
			{
				_value = this.record;
			}
			//var _value = (this.record&&this.props.dataField)?this.record[this.props.dataField]:"";
			this.setDisplay(_value);

			if(this.props.control)
			{

				var _allowEdit = true;
				if(!this.record && groupAlias)
				{
					_allowEdit = false;
				}
				else
				{
					_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
				}
				this.doSetEnable(_allowEdit);	
			}
		}
	}

	onDatePanelClose()
	{
		this.lookupStates.isShowed = false;
		//this.setFinalValue();
		//this.setDisplay();
	}

	selectChangeDate()
	{
		//alert($(this.inputField).val());
		this.setFinalValue();
		this.setDisplay();
	}

	componentDidMount()
	{
		super.componentDidMount();
		$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);

		let _displayStyle = this.props.control.getProperty_DisplayStyle();
		let dataFormat ;
		if(_displayStyle && _displayStyle.DisplayFormat)
		{
			dataFormat = _displayStyle.DisplayFormat;
		}
		else
		{
			// dataFormat = _displayStyle.DisplayFormat;
		}
		let startView=0;
		let minViewMode=0;
		let format = "yyyy-mm-dd";
		if(!dataFormat || dataFormat == "yyyy-MM-dd" || dataFormat == "MM-dd"){
			 startView=0;
			 minViewMode=0;
		}else if(dataFormat == "yyyy-MM"){
			startView=1;
			minViewMode=1;
		}else if(dataFormat == "yyyy"){
			startView=2;
			minViewMode=2;
		}

		$(this.inputField).datepicker({
			language: 'zh-CN',
			autoclose: true,//选中之后自动隐藏日期选择框
			clearBtn: true,//清除按钮
			todayBtn: true,//今日按钮
			todayHighlight:true,
			format: format,
			buttonImageOnly: true,
			startView: startView,
			minViewMode: minViewMode,
			hide:this.onDatePanelClose.bind(this)
		   
		}).on('selectChangeDate',this.selectChangeDate.bind(this));


				
		 //此处跟Flex有差别 无法精确判断焦点关联对象 relatedTarget只有在文本框类dom节点才有值 否则为null
		 //不能获得焦点的比如下拉框div仍然可以使得input失去焦点
		 $(this.inputField).blur(function(event){
		 	  /*if(event.relatedTarget!=null && event.relatedTarget == this.refs.inputpicker)
		 	  {
		 	  	return;
		 	  }*/
		  	  //$(this).val("06-06");
		 });

		if(this.props.underQueryGroup)
		{

				this.doSetEnable(false);
		}
		else
		{
			let _initRecord;
			if(this.props.dataField)
			{
				_initRecord = this.props.initRecord;
			}
			else
			{
				if(this.props.control.hasInitEditorValue)
				{
					_initRecord = this.props.initEditorValue;	
				}
				else
				{
					_initRecord = this.props.initRecord;
				}
				//_initRecord = this.props.initEditorValue;
			}
			this.onCurrentRecordChanged(null,_initRecord,this.props.groupAlias,this.props.moduleInstanceId);	
		}

		if(this.props.initEditorValue && !this.props.dataField)
		{
			this.setFinalValue(this.props.initEditorValue,false);
			this.setDisplay();
		}
	}

	doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			this.setState({allowEdit:false});
		}
		else if(nowAllowEdit == false && enable == true)
		{
			this.setState({allowEdit:true});
		}
	}

	onBeforeAutoSave(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			if($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length)
			{
				let text = $(this.inputField).val();
				let _val;
				_val = FormItemDateResolver.getResult(text,false);
				if(_val.indexOf("false:") == 0)
				{
					//alert(_val.substr(6));
					return false;
				}
				if(this.props.groupAlias == "")
				{
					this.record = _val;
				}
				else
				{
					let changed = false;
					let oldValue = this.record[this.props.dataField];
					let newValue = _val;
					if(oldValue != newValue)
						changed = true;
					this.record[this.props.dataField] = newValue;
					//alert("派发");	
					if(changed)	
					{
						RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
						if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"");
					}
					this.updateModifiedTag();
				}
			}
		}
		return true;
		
	}

	setFinalValue(value,triggerModified = true)
	{
		if(this.props.underQueryGroup){
			var reg = "^[ ]+$";
			var rege = new RegExp(reg);
			if(rege.test($(this.inputField).val())){
				$(this.inputField).val('-只查空值-');
				this.record = '-只查空值-';
				value='-只查空值-';
				this.state.nullValue = true;
			}else if($(this.inputField).val() == '-只查空值-' || $(this.inputField).val()=='-'){
				$(this.inputField).val('-只查空值-');
				value='-只查空值-';
			}else if(value=='-点此填值-'){
				$(this.inputField).val('-点此填值-');
				value='';
			}else{
				if(value == undefined || value == null)
					value = $(this.inputField).val();
				if(value == "t" || value == "T")
				{
					var today = new Date();
					value = today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate();
				}
				if(value)
				{
					value = FormItemDateResolver.getResult(value,false);
					if(value.indexOf("false:") == 0)
					{
						Warning.show({text:value.substr(6)});
						return FormItemConst.EDITOR_VALUE_CHANGED_ERROR;
					}
				}
			}
		}else{
			if(value == undefined || value == null)
				value = $(this.inputField).val();
			if(value == "t" || value == "T")
			{
				var today = new Date();
				value = today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate();
			}
			if(value)
			{
				value = FormItemDateResolver.getResult(value,false);
				if(value.indexOf("false:") == 0)
				{
					Warning.show({text:value.substr(6)});
					return FormItemConst.EDITOR_VALUE_CHANGED_ERROR;
				}
			}
		}
		
		if(!this.props.dataField)
		{
			if(this.props.groupAlias == "" || !this.props.groupAlias)
			{
				var oldValue = this.record;var newValue = value;this.record = value;
			
				if(this.props.control && oldValue != newValue && triggerModified)
				{
					this.props.control.doModifiedEditor(oldValue, newValue,this);
				}
			}
			//TODO_YL 修改报错回正
			// this.record = value;
		}
		else
		{
			let changed = false;
			let oldValue = (this.record&&this.props.dataField)?this.record[this.props.dataField]:(this.record?this.record:"");
			let newValue = value;
			if(oldValue != newValue)
				changed = true;
			this.record[this.props.dataField] = newValue;
			//alert("派发");	
			if(changed)	
			{
				RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
				if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"",null,this);
			}
			this.updateModifiedTag();
		}

		return FormItemConst.EDITOR_VALUE_CHANGED_SUC;
	}

	//新框架避免增加复杂条件判断 所以该类只表示Form上FormItem
	inputFieldBlur()
	{
		
		if(this.lookupStates.isShowed)
			return;
		if(this.props.underQueryGroup && $(this.inputField).val()==""){
			this.state.notNull = false
			this.setState({allowEdit:false,nullValue:false})
			this.inQueryGroup = false;
		}else{
			if(this.props.control && this.props.control.getProperty_AllowEdit_Final() == true)
			{
				//todo 值回送数据完成以后 严格按照显示要求再进行显示
				this.setFinalValue();
				this.setDisplay();
			}
			if(this.props.control && this.props.xml.createdLayer == 'bug'){
				this.setFinalValue();
				this.setDisplay();
			}
		}

		if(this.holdFocus)
		{
			$(this.inputField).focus();
			$(this.inputField).select();
		}
	}

	restoreValue(_value)
	{
		if(!this.props.dataField)
		{
			this.record = _value;
		}
		else if(this.record)
		{
			this.record[this.props.dataField] = _value;
		}
		this.setDisplay();
	}
	setDisplay(value)
	{
		if(this.props.underQueryGroup && this.record == '-只查空值-'){
			return;
		}
		if(value == null || value == undefined)
		{
			if(this.props.dataField && this.record)
				value = this.record[this.props.dataField];
			else
				value = this.record;
		}
		if(document.activeElement && document.activeElement == this.inputField)
		{

		}
		else
		{
			let _displayStyle = this.props.control.getProperty_DisplayStyle();
			if(_displayStyle && _displayStyle.DisplayFormat)
			{
				value = FormItemDateDisplay.getDisplayText2(value,_displayStyle.DisplayFormat.toUpperCase());
			}
			else
			{
				value = FormItemDateDisplay.getDisplayText(value,this.props.show1970,this.props.seperator,this.props.numOfDay,this.props.numOfMonth,this.props.numOfYear);
			}
			
		}
			

		$(this.inputField).val(value);
	}

	inputFieldFocus()
	{
		//return;
		window.lastFocusUI = this.inputField;
		if(this.props.groupAlias)
			window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
		if(this.lookupStates.isShowed)
			return;
		if(!this.props.dataField)
		{
			$(this.inputField).val(this.record);
		}
		else
		{
			let _recordValue = this.record==null?"":this.record[this.props.dataField];
			$(this.inputField).val(_recordValue);	
		}
		if(this.state.underQueryGroup){
			if($(this.inputField).val() == '-只查空值-'){
				$(this.inputField).val('');
				this.record='';
			}
		}
		var _parentWindow =window;	
		if(_parentWindow.notClickFocusEditor){
			_parentWindow =window;
		}else if(window.parent.window.notClickFocusEditor){
			_parentWindow =window.parent.window;
		}
		if(_parentWindow.notClickFocusEditor == undefined || (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '')
			|| (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1 )){
			$(this.inputField).select();
		}
	}

	onKeyDownHandler(e)
	{
		if(super.onKeyDownHandler(e))
			return;
		if(!e.ctrlKey && e.keyCode>64&&e.keyCode<91&&e.keyCode!=84)
		{
			e.preventDefault();
		}
	}
	inputCloseOnClick(){
		$(this.inputField).val('');
		this.record='';
		this.setState({allowEdit:false,nullValue:false})
		this.inQueryGroup = false;
	}

	inputFieldOnClick(){
		if(this.props.underQueryGroup){
			this.state.notNull = false
			this.setState({allowEdit:true,nullValue:false})
			this.inQueryGroup = true;
		}
	}

	inputFieldDbClick()
	{
		var _parentWindow =window;	
		if(_parentWindow.notClickFocusEditor){
			_parentWindow =window;
		}else if(window.parent.window.notClickFocusEditor){
			_parentWindow =window.parent.window;
		}
		if(_parentWindow.notClickFocusEditor == undefined || (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '')
			|| (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1 )){
			$(this.inputField).select();
		}
	}

	getInputDom(_width)
	{
		if(this.state.allowEdit)
		{
			let height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT;
			if(this.props.displayHeight){
				height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT*(Number(this.props.displayHeight));
			}
			let _style = {padding:'2px',paddingRight:'13px',height:(height)+'px',width:_width,fontSize:"12px"};
			_style.textAlign = this.props.textAlign.toLowerCase();
			if(this.props.cssStyle)
			{
				Object.assign(_style,this.props.cssStyle);
			}
			if(this.state.color && this.state.color != -1)_style.color = this.state.color;
			if(this.state.backgroundColor && this.state.backgroundColor != -1)_style.backgroundColor = this.state.backgroundColor;
			if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
			if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
			if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
			if(this.props.customStyle)Object.assign(_style,this.props.customStyle);


			if(this.props.underQueryGroup){

				_style.border ='none'
				_style.height =parseInt(height)-2+'px';
				_width = _width.replace('px','');
				_style.width=parseInt(_width)+11+'px';
				return	<div style={{position:'relative',width:'100%',height:'22px',marginRight:'12px',border:'1px solid #ccc'}} >
						<input spellCheck="false" autoComplete="off" ref={ node => this.inputField = node } id={"input"+this.props.xml.id} 
		        	   type="text" className="form-control" style={_style}
		        	   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>
						<i className="fa fa-times-circle" style={{position: 'absolute',right: '14px',top:'5px',zIndex:'1000',color:'gray',fontSize:'1px'}} onClick={this.inputCloseOnClick.bind(this)}></i>	
					</div>
			// return 	<input spellCheck="false" autoComplete="off" ref={ node => this.inputField = node } id={"input"+this.props.xml.id} 
		    //     	   type="text" className="form-control pull-right" style={_style}
		    //     	   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>;
			}else{
				

			return 	<input spellCheck="false" autoComplete="off" ref={ node => this.inputField = node } id={"input"+this.props.xml.id} 
		        	   type="text" className="form-control pull-right" style={_style}
		        	   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>;
			}
		}	
		else
		{
			let height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT;
			if(this.props.displayHeight){
				height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT*(Number(this.props.displayHeight));
			}
			let _style = {padding:'2px',paddingRight:'13px',height:(height)+'px',width:_width,backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,fontSize:"12px",cursor:'text'};
			_style.textAlign = this.props.textAlign.toLowerCase();
			if(this.props.cssStyle)
			{
				Object.assign(_style,this.props.cssStyle);
			}
			if(this.state.color && this.state.color != -1)_style.color = this.state.color;
			if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
			if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
			if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
			if(this.props.customStyle)Object.assign(_style,this.props.customStyle);

			if(this.props.underQueryGroup){
				_width = _width.replace('px','');
				_style.width=parseInt(_width)+25+'px';
				let defaultValue='-点此填值-';
				_style.textAlign='center';
				return <div >
				<input spellCheck="false" autoComplete="off" ref={ node => this.inputField = node } id={"input"+this.props.xml.id} readOnly="readonly" 
				type="text" className="form-control pull-right" style={_style}
				onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)} value={defaultValue} onClick={this.inputFieldOnClick.bind(this)} />
				<i className="fa fa-times-circle" style={{position: 'absolute',right: '14px',top:'3px',zIndex:'1000',display:'none'}} onClick={this.inputCloseOnClick.bind(this)}></i>	
				</div>


			}else{

				_style.paddingRight='2px'
			return	 <input spellCheck="false" autoComplete="off" ref={ node => this.inputField = node } id={"input"+this.props.xml.id} readOnly="readonly" 
		        	   type="text" className="form-control pull-right" style={_style}
		        	   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>;
		
						}
		}
	}

	getDownArrowButtonDom()
	{
		if(this.state.allowEdit)
		{
			
				if(this.props.underQueryGroup){
					return <i ref={node => this.downArrowButton = node} onMouseDown={this.showDateDropDown.bind(this)} className="fa fa-calendar" style={{position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
				}else{
					return <i ref={node => this.downArrowButton = node} onMouseDown={this.showDateDropDown.bind(this)} className="fa fa-calendar" style={{display:'none',position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
				}
			
			//return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'18px',paddingLeft:'0px',paddingRight:'0px',height:'22px',paddingBottom:'2px'}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
		}
		else
		{
			if(this.props.underQueryGroup){
				return <i ref={node => this.downArrowButton = node} onMouseDown={this.showDateDropDownEditor.bind(this)} className="fa fa-calendar" style={{position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>
			}else{
				return <i ref={node => this.downArrowButton = node} className="fa fa-calendar" style={{display:'none',position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>
			}
			
			//return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'18px',paddingLeft:'0px',paddingRight:'0px',height:'22px',paddingBottom:'2px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
		}
	}
	showDownArrow(){
		if(this.props.underQueryGroup){return}
		if(this.state.allowEdit){
			$(this.downArrowButton).show();
		}
	}
	hideDownArrow(){
		if(this.props.underQueryGroup){return}
		if(this.state.allowEdit){
			$(this.downArrowButton).hide();
		}
	}
	render()
	{
		let inputgroupWidth = (this.props.displayLengthWidth + 30)+"px";
		let _display = this.currentDataFieldChanged?"block":"none";
		let displayLength=this.state.displayLength;
		let paddingRightValue = 0;
		if(displayLength == FormItemConst.DATEEDITOR_DEFAULT_DISPLAYLENGTH)displayLength=FormItemConst.DATEEDITOR_DEFAULT_DISPLAYLENGTH+1;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+paddingRightValue+'px';
		let notNull=this.state.notNull;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull){
			_notNullStyle['visibility']='hidden';
		}else if(this.props.underQueryGroup){
			_notNullStyle['visibility']='hidden';
		}

		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		if(_display == "block")editorStyle.backgroundColor = "#f8e8b7";
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) editorStyle.display="none"; else editorStyle.visibility="hidden";

			// _notNullStyle['display']='none';
		let widthProValue = this.props.control.getProperty_Width();
		let middleStyle = {};
		if(widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1)
		{
			_width = "100%";middleStyle.width = widthProValue;editorStyle.width = "100%";
		}

		let inputdom = this.getInputDom(_width);
		let downArrowButtonDom = this.getDownArrowButtonDom();
		let labelStyle = {paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
		// if(this.state.underQueryGroup && !this.inQueryGroup)
		// {
		// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
		// }
		if(!this.props.label){labelStyle.display = "none";_notNullStyle.display = "none"}
		return (
			<div id={this.props.xml.name} className='editorGroup' ref={node=>this.contextMenuHandler=node} style={editorStyle}>
			  <label htmlFor={"input"+this.props.xml.id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle} onClick={this.labelClickHandler.bind(this)}>
			  		 {this.state.label}
			  </label>
			  <i className='fa fa-snowflake-o' style={_notNullStyle}></i>
			  <div className="input-group date" style={middleStyle} onMouseEnter={this.showDownArrow.bind(this)} onMouseLeave={this.hideDownArrow.bind(this)}>
			  	{inputdom}{downArrowButtonDom}
		        <i ref={node => this.modifiedTag = node} className="fa fa-sort-asc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-5px",right:"-3px",fontSize:"11px",transform:'rotate(45deg)',zIndex:"100",marginRight:'4.5px',marginTop:'4px',display:_display}}></i>
		      </div>
		       
			</div>

			/*
				<div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
					<label htmlFor={"input"+this.props.xml.id} 
						style={{paddingLeft:'5px',paddingRight:'5px',width:'auto'}}>{this.props.xml.name}</label>
					<div className="input-group" style={{width:inputgroupWidth}} ref='inputgroup'>
				        <input ref='inputdom' id={"input"+this.props.xml.id} type="text" className="form-control" style={{padding:'2px'}}/>
				        <span className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px'}} onClick={this.buttonDownClick.bind(this)}><i className="fa fa-sort-desc"></i></span>
				    </div>
				</div>
			*/
		);
	}
}



// WEBPACK FOOTER //
// ./src/formItem/FormItemDateEditor.js